// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3-njO","cards":"Dashboard_cards__143jW"};